import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import * as PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import styles from './View.Style'

const FileUploader = props => {
  const { classes, dropText, onFileSelect, accept, multiple } = props

  const onDrop = useCallback(acceptedFiles => {
    onFileSelect(acceptedFiles[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept, multiple })
  return (
    <div className={classes.root} {...getRootProps()}>
      <input {...getInputProps()} />
      <span className="icon-upload" />
      <p>{dropText}</p>
    </div>
  )
}

FileUploader.defaultProps = {
  dropText: '',
  multiple: false,
  accept: process.env.REACT_APP_VALID_FILE_TYPES,
}

FileUploader.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }).isRequired,
  dropText: PropTypes.string,
  onFileSelect: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  accept: PropTypes.string,
}

export default withStyles(styles)(FileUploader)
